let aaa = 'aaa'
export default {
  aaa
}



// WEBPACK FOOTER //
// ./src/store/sys_manage/state.js